// LoadingPage.jsx
import React from 'react';
import { CircularProgress, Typography, Box } from '@mui/material';

const LoadingPage = ({ message = "Loading..." }) => {
  return (
    <Box 
      sx={{
        height: '1024px',
        width: '100%',
        display: 'flex',
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <CircularProgress />
      <Typography variant="h6" sx={{ marginTop: 2 }}>
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingPage;
